import styled from "styled-components";
import { lighten } from "polished";
import { Variables } from "../../styles/Variables";

export const Label = styled.label`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
  width: 100%;

  & input {
    box-sizing: border-box;
    outline: none;
    padding: 0 16px;
    border: 2px solid ${Variables.colorGrayLines};
    border-radius: 70px;
    font-size: 16px;

    & ::placeholder {
      color: #d7d7d7;
    }

    & :hover {
      border: 2px solid ${lighten(0.2, Variables.colorOrange)};
    }

    & :focus {
      border: 2px solid ${Variables.colorOrange};
    }
  }
`;

export const ContainerIcon = styled.div`
  position: absolute;
  right: 3%;
  top: 45%;
`;
